import { useEffect, useMemo, useCallback } from "react";
import type { ReactElement } from "react";
import { Box, Button, Flex, Image, Link, Text } from "@chakra-ui/react";
import { ExternalLinkIcon } from "@chakra-ui/icons";

import { LP_BANNER_CTA_CLICK, LP_VIEW_BANNER } from "../../constants/firebase";

import { trackEvent } from "../../utils/firebase";

type Props = {
  open: boolean;
  close: () => void;
  text: string;
  ctaText: string;
  ctaLink: string;
};

const IS_CLOSABLE_BANNER = false;
const textStyle = { base: "p12" as const, lg: "p14" as const };

const Banner = ({ open, close, text, ctaText, ctaLink }: Props) => {
  useEffect(() => {
    trackEvent(LP_VIEW_BANNER);
  }, []);

  if (!open) {
    return null;
  }

  const handleCtaClick = () => {
    trackEvent(LP_BANNER_CTA_CLICK, {
      cta_text: ctaText,
      cta_link: ctaLink,
    });
  };

  return (
    <Box
      w="100vw"
      py="10px"
      px={IS_CLOSABLE_BANNER ? 5 : 0}
      pr={IS_CLOSABLE_BANNER ? 10 : 0}
      bg="#FBC828"
      color="white"
      pos="relative"
      zIndex={1500}
    >
      <Flex
        flexDir={{ base: "column", lg: "row" }}
        align="center"
        justify="center"
        gap={{ base: 2, lg: 3 }}
      >
        <>
          {
            ctaLink ? (
              <Link
                isExternal
                href={ctaLink}
                onClick={() => handleCtaClick()}
                _hover={{ textDecoration: "none" }}
              >
                <Flex
                  as="span"
                  role="group"
                  display="inline-flex"
                  alignItems="center"
                  gap={1}
                  cursor="pointer"
                  transition="all 0.2s ease"
                >
                  <Text
                    as="span"
                    textStyle={textStyle}
                    fontWeight="600 !important"
                    color="textPrimary"
                    textDecoration="underline"

                  >
                    {text}
                  </Text>
                  <ExternalLinkIcon
                    color="textPrimary"
                    boxSize="14px"
                  />
                </Flex>
              </Link>
            ) : (
              <Text
                textStyle={textStyle}
                fontWeight="600 !important"
                color="textPrimary"
              >
                {text}
              </Text>
            )
          }
        </>
        <Flex flexDir="row" gap={3} alignItems="center">

          <Link
            isExternal
            href="https://www.staderlabs.com/bnb/stake/"
          >
            <Button
              size="sm"
              bg="white !important"
              color="textPrimary !important"
              _hover={{ bg: "white", color: "textPrimary" }}
              fontSize={14}
              fontWeight={600}
              h={7}
            >
              Proceed to unstake
            </Button>
          </Link>


        </Flex>
      </Flex>
      {
        IS_CLOSABLE_BANNER && (
          <Box
            pos="absolute"
            top={17}
            right={18}
            float="right"
            onClick={close}
            cursor="pointer"
          >
            <Image src="/assets/images/cross.svg" alt="close" />
          </Box>
        )
      }

    </Box>
  );
};

export default Banner;
